export const ko_KO = {
    "PREFIX": {
        "QUESTION": "문항",
        "QUESTION-PART": "문항",
        "PRE-RELEASE": "Pre-Release",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "{{totalMarks > 1 && '점' || '점'}}"
    }
};